// assets/custom-clean-url-params.js
(() => {
  try {
    const url = new URL(window.location.href);

    // Remove ONLY "srsltid" (Google search landing param)
    if (url.searchParams.has('srsltid')) {
      url.searchParams.delete('srsltid');

      const newUrl =
        url.pathname +
        (url.searchParams.toString() ? `?${url.searchParams.toString()}` : '') +
        url.hash;

      // No reload, just clean the visible URL
      window.history.replaceState({}, '', newUrl);
    }
  } catch (e) {
    // fail silently
  }
})();
